const quotationChat = {
  quotationChatNavLabel: "تغير عرض السعر", // translated 
  quotationChatApprovalTitle: "تغير عرض السعر", // translated 
  quotationChatAccountNotApprovedTitle: "الحساب غير معتمد", // translated 
  quotationChatAccountNotApprovedDescription:
    "لم يتم التحقق من حسابك بعد ذلك. يرجى التواصل مع مدير حسابك للمزيد من المعلومات.", // translated 
  quotationChatViewAiChat: "عرض الذكاء الاصطناعي", // translated 
  quotationRequestChatSessions: "أطباء", // translated 
  quotationRequestChatNoPastSessions: "لا توجد جلسات سابقة", // translated 
  quotationRequestChatNewChat: "دوسوا", // translated 
  quotationRequestChatCloseSidebar: "إغلاق الشريط الجانبي", // translated 
  quotationRequestChatSessionFallback: "مركز", // translated 
  quotationRequestChatDefaultSessionName: "جلسة حوار جديدة", // translated 
  quotationRequestChatTitle: "طلب عرض السعر", // translated 
  quotationRequestChatResponseLanguageLabel: "لغة البورتريه", // translated 
  quotationRequestChatOpenSidebar: "فتح الشريط الجانبي", // translated 
  quotationRequestChatRenameSession: "إعادة الاتصال", // translated 
  quotationRequestChatDeleteSession: "دراما", // translated 
  quotationRequestChatToggleDarkMode: "التغيير الجديد", // translated 
  quotationRequestChatSwitchToLightMode: "التبديل إلى الوضع الفاتح", // translated 
  quotationRequestChatSwitchToDarkMode: "التبديل إلى الوضع السائد", // translated 
  quotationRequestChatEmptyStateHeading: "ابدأ جديدة لطلب عرض السعر", // translated 
  quotationRequestChatEmptyStateSubheading:
    "صف لديكم وسوفُ يطلب منشئ عرض السعر لك.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "اكتب رسالتك لبدء التسجيل... (Shift+Enter سطر جديد)", // translated 
  quotationRequestChatMessagePlaceholder:
    "اكتب رسالتك... (Shift+Enter سطر جديد)", // translated 
  quotationRequestChatUploadFile: "ملف تعريفي", // translated 
  quotationRequestChatUploadAttachment: "رقابة", // translated 
  quotationRequestChatStopGenerating: "بطن التبت", // translated 
  quotationRequestChatGenerateQuotation: "عرض خاص", // translated 
  quotationRequestChatGenerateFinalQuotation: "إنشاء عرض النهائي", // translated 
  quotationRequestChatFinalizeQuotationRequest: "طلب إنهاء عرض السعر", // translated 
  quotationRequestChatHoldToRecord: "اضغط على أحدث رسالة صوتية", // translated 
  quotationRequestChatRecordingReleaseToSend: "جار التسجيل، اترك للإرسال", // translated 
  quotationRequestChatRecording: "راف تكساس...", // translated 
  quotationRequestChatSelectSessionFirst: "يرجى اختيار الجلسة الجديدة.", // translated 
  quotationRequestChatCancelVoiceRecording: "إلغاء التسجيل الصوتي", // translated 
  quotationRequestChatListening: "شهادة خاصة...", // translated 
  quotationRequestChatTranscribing: "حُرمة واحدة لا...", // translated 
  quotationRequestChatFileUploadedSuccess: "تم رفع الملف الفعال.", // translated 
  quotationRequestChatFailedCreateSession: "فشل إنشاء المحكمة. من فضلك حاول مرة أخرى.", // translated 
  quotationRequestChatFailedUploadFile: "فشل في رفع الملف. من فضلك حاول مرة أخرى.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "يرجى الإجابة على الأسئلة المعلقة قبل إرسال رسالة أخرى.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "يرجى الإجابة على الأسئلة المعلقة قبل طلب عرض السعر.", // translated 
  quotationRequestChatFavoriteMarked: "تم وضع علامة على المحكمة كمفضلة", // translated 
  quotationRequestChatFavoriteUnmarked: "نيابة عن المحكمة الجنائية الدولية", // translated 
  quotationRequestChatFailedSetFavorite: "فشل تعيين القديم", // translated 
  quotationRequestChatFailedUnsetFavorite: "فشل في إزالة الحب", // translated 
  quotationRequestChatRenamedSuccess: "إعادة تسمية المحكمة فعالة.", // translated 
  quotationRequestChatFailedRename: "إعادة تسمية المحكمة لأول مرة. من فضلك حاول مرة أخرى.", // translated 
  quotationRequestChatDeletedSuccess: "تم حذف المساعدة الفعالة.", // translated 
  quotationRequestChatFailedDelete: "فشل حذف كندا. من فضلك حاول مرة أخرى.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "تم حذفه بشكل فعال.", // translated 
  quotationRequestChatFailedDeleteAttachment: "فشل في حذف المرفق. من فضلك حاول مرة أخرى.", // translated 
  quotationRequestChatSubmittedSuccess:
    "تم تقديم الطلب بسعر فعال! تساءلت عما إذا كان الأمر يتعلق بـ", // translated 
  quotationRequestChatFailedSubmit: "فشل في تقديم الطلب عرض السعر", // translated 
  quotationChatPdfDownloadedSuccess: "تم تنزيل PDF فعال!", // translated 
  quotationChatFailedGeneratePdf: "ملف PDF", // translated 
  quotationRequestChatSubagentRequired:
    "يرجى اختيار المستخدم المباشر قبل تقديم الطلب لعرض السعر.", // translated 
  quotationRequestChatAppUserLoading:
    "ملف مستخدم تطبيق CRM الخاص بك لا يزال قيد التحميل. يرجى المحاولة بعد لحظة.", // translated 
  quotationRequestChatAppUserMismatch:
    "ملف مستخدم تطبيق CRM الخاص بك لا يتطابق مع المحكمة الكندية هذه.", // translated 
  quotationRequestChatRenameTitle: "إعادة تسمية محكمة العدل الدولية", // translated 
  quotationRequestChatSessionName: "اسم", // translated 
  quotationRequestChatEnterSessionName: "اسم سريع", // translated 
  quotationRequestChatSaving: "جارِئ الحفظ...", // translated 
  quotationRequestChatSave: "سبي", // translated 
  quotationRequestChatDeleteTitle: "إلغاء دعوى قضائية جديدة", // translated 
  quotationRequestChatDeleteConfirm: "هل أنت متأكد أنك ترغب في إلغاء محكمة هذه الكنيسة؟", // translated 
  quotationRequestChatDeleteCannotUndo: "لا يمكن السماء عن هذا الإجراء.", // translated 
  quotationRequestChatDeleting: "جارح التاجر...", // translated 
  quotationRequestChatDelete: "3", // translated 
  quotationRequestChatAttachmentsTitle: "تفاصيل جديدة طلب عرض السعر", // translated 
  quotationRequestChatLoadingAttachments: "جارٍ تحميلات...", // translated 
  quotationRequestChatNoAttachments: "لم يتم العثور على المرفقات", // translated 
  quotationRequestChatDeleteAttachment: "يونيو", // translated 
  quotationRequestChatUploadingAttachment: "جارٍ رفع المرفق...", // translated 
  quotationRequestChatUploadingAttachmentWait:
    "انتظر الانتظار أثناء رفع ملفك.", // translated 
  quotationRequestChatAnswerPendingQuestions: "الإجابة على الأسئلة", // translated 
  quotationRequestChatProposeOwnAnswer: "اقترح إجابتي الخاصة", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "اكتب إجابتك الخاصة...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{answered}} من {{total}} الإجابة الإجابة", // translated 
  quotationRequestChatReadyToSubmit: "عربوسال", // translated 
  quotationRequestChatSubmitAll: "جيب كون", // translated 
  quotationRequestChatRespondToOneQuestion: "الرد على {{count}} سؤال", // translated 
  quotationRequestChatRespondToManyQuestions: "الرد على {{count}} أسئلة", // translated 
  quotationRequestChatFinalizeTitle: "طلب إنهاء عرض السعر", // translated 
  quotationRequestChatLoadingSessionData: "جارٍ تحميل بيانات الجلسة...", // translated 
  quotationRequestChatErrorLoadingSession: "خطأ في تحميل بيانات الجلسة. من فضلك حاول مرة أخرى.", // translated 
  quotationRequestChatQuotationTitle: "عروض خاصة", // translated 
  quotationRequestChatExtraComments: "ولاية", // translated 
  quotationRequestChatSubmitting: "كاراكين...", // translated 
  quotationRequestChatSubmit: "ثالثًا", // translated 
  quotationRequestChatSubmittingOverlayTitle: "جارٍ تقديم طلب عرض السعر...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "يرجى الانتظار أثناء تقديم الطلب.", // translated 
  quotationRequestChatSelectSubagent: "اختر الوكيل الخارجي", // translated 
  quotationRequestChatSearchSubagents: "البحث عن وكلاء فرعيين...", // translated 
  quotationRequestChatLoadingSubagents: "جارٍ تحميل الوكلاء الفرعيين...", // translated 
  quotationRequestChatNoSubagentsFound: "لم يتم العثور على وكلاء فرعيين", // translated 
  quotationRequestChatNoSubagentsAvailable: "لا يوجد وكلاء فرعيون متاحون", // translated 
  quotationRequestChatSelectedSubagent: "الدرجات: {{label}}", // translated 
  quotationRequestChatSubagentUsers: "المستخدم الخارجي", // translated 
  quotationRequestChatSearchUsers: "ابحث عن مستخدمين...", // translated 
  quotationRequestChatNoUsersFound: "لم يتم العثور على مستخدمين", // translated 
  quotationRequestChatNoUsersAvailable: "لا يوجد مستخدمون متاحون", // translated 
  quotationChatDownloadSummaryTitle: "تنزيل ملخص عرض السعر", // translated 
  quotationChatDownloadSummaryDescription:
    "أدخل بياناتك أدناه إلى ملخص PDF مخصص لعرض سعر الرحلة. سيتضمن PDF جميع تفاصيل الطيران والوجهات ومعلومات النقل والبرنامج اليومي.", // translated 
  quotationChatCustomerTitle: "أج", // translated 
  quotationChatSelectTitle: "يونايتد", // translated 
  quotationChatHonorificMr: "سرير", // translated 
  quotationChatHonorificMrs: "ل", // translated 
  quotationChatHonorificMs: "الآن", // translated 
  quotationChatHonorificDr: "د.", // translated 
  quotationChatHonorificProf: "أ.د.", // translated 
  quotationChatCustomerPhone: "الشخصية", // translated 
  quotationChatCustomerCompany: "ستيل", // translated 
  quotationChatCustomerMessage: "العلوم", // translated 
  quotationChatCustomerCountry: "البلد", // translated 
  quotationChatGenerating: "جارين البورت...", // translated 
  quotationChatDownloadPdf: "إعادة تحميل ملف PDF", // translated 
  quotationChatTripSummary: "مجددًا", // translated 
  quotationChatDownloadAsPdf: "نزين كـ PDF", // translated 
  quotationChatNoTripSummary: "لا مختصر رحلة لهذه النظرة.", // translated 
  quotationRequestChatThinking: "ريسة...", // translated 
  quotationRequestChatSources: "الـ", // translated 
  quotationRequestChatSearchingWebFor: 'البحث في الويب عن: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "الخدمات الخارجية من قبل منظم الرحلات الجوية", // translated 
  quotationRequestChatServicesByCustomer: "الخدمات التي يقدمها العميل", // translated 
  quotationRequestChatReadyNotice:
    "يمكنك الآن إنشاء عرض سعر هذا الطلب بالنقر على الزر على اللغة الإنجليزية.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "إنشاء عرض النهائي", // translated 
  quotationRequestChatMaybeYouWantToAsk: "ربما تريد أن تسأل:", // translated 
  quotationRequestChatClickToSendSuggestion: "انقر هذه الرسالة", // translated 
  quotationRequestChatAddToFavorites: "إضافة إلى خيار", // translated 
  quotationRequestChatRemoveFromFavorites: "إزالة من المحبة", // translated 
  quotationRequestChatSubmitted: "تيمون", // translated 
  quotationRequestChatQuotationRequest: "طلب عرض السعر: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{عنوان}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- الدرجة: {{status}}", // translated 
  quotationChatLoading: "رافو...", // translated 
  quotationChatSessionNotFound: "لم يتم العثور على جلسة الاستماع لهذا العرض", // translated 
  quotationChatMemberSessionNotFound: "لم يتم العثور على جلسة عمل كعضو لحسابك", // translated 
  quotationChatUnableToConnect: "عذر الاتصال بالمحادثة", // translated 
  quotationChatConnecting: "دارا حفيد...", // translated 
  quotationChatTypeYourMessage: "اطبخ أكلتك...", // translated 
  quotationChatConnected: "متصل", // translated 
  quotationChatConnectingStatus: "دارا حفيد...", // translated 
  quotationChatDisconnected: "علم", // translated 
};


export default quotationChat;
